<template>
  <div class="container-fluid">
    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary"
        style="margin-right: 5px"
        @click="createMenuModal({ type: 'parent' })"
      >
        {{ i18n("Buttons.Add") }}
      </button>
      <button
        type="button"
        class="btn btn-info"
        data-toggle="modal"
        data-target="#localizationModal"
        @click="tableData = JSON.parse(JSON.stringify(originalData))"
      >
        多國語系
      </button>
    </div>

    <!-- 選單 -->
    <div class="yahome-table-wrap">
      <VueTreeGrid
        :key="treeKey"
        :columns="columns"
        :tree="tree"
        emptyText="暫無資料"
        @expand="expandMenu"
      >
        <template slot="sort--row-cell" slot-scope="scope">
          <div class="text-center">
            <button
              v-if="scope.row._index !== 0"
              class="btn btn btn-outline-secondary btn-sm"
              @click="changeSort({ item: scope.row, action: 'up' })"
            >
              <i class="fas fa-long-arrow-alt-up" />
            </button>

            <span v-if="scope.row._level === 1">
              <button
                v-if="scope.row._index !== tree.length - 1"
                class="btn btn btn-outline-secondary btn-sm"
                @click="changeSort({ item: scope.row, action: 'down' })"
              >
                <i class="fas fa-long-arrow-alt-down" />
              </button>
            </span>
            <span v-if="scope.row._level === 2">
              <button
                v-if="scope.row._index !== scope.row.childrenLength - 1"
                class="btn btn btn-outline-secondary btn-sm"
                @click="changeSort({ item: scope.row, action: 'down' })"
              >
                <i class="fas fa-long-arrow-alt-down" />
              </button>
            </span>
          </div>
        </template>
        <template slot="menuName--row-cell" slot-scope="scope">
          <template v-if="scope.row.LocalizationalMenus.length > 0">
            <span
              v-for="item in scope.row.LocalizationalMenus"
              :key="item.LocalizationTypeGuid"
            >
              <span v-if="item.LocalizationTypeCode === currentLanguage">
                {{ item.MenuName ? item.MenuName : scope.row.MenuName }}
              </span>
            </span>
          </template>
          <span v-else>
            {{ scope.row.MenuName }}
          </span>
        </template>
        <template slot="action--row-cell" slot-scope="scope">
          <button
            v-if="scope.row._level === 1"
            type="button"
            class="btn btn-primary btn-sm"
            @click="createMenuModal({ type: 'child', data: scope.row })"
          >
            {{ i18n("Buttons.Add") }}
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm"
            @click="editMenuModal(scope.row)"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delMenu"
            @click="deleteTemp = scope.row"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
      </VueTreeGrid>
    </div>

    <!-- 多國語系 Modal -->
    <div class="modal" id="localizationModal" tabindex="-1" data-focus="false">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">多國語系</h5>
          </div>
          <div class="modal-body">
            <div>
              <el-table
                :data="tableData"
                row-key="MenuGuid"
                border
                height="800"
                default-expand-all
                :tree-props="{
                  children: 'Children',
                }"
              >
                <el-table-column
                  fixed
                  prop="MenuName"
                  label="選單名稱"
                  width="180"
                >
                </el-table-column>

                <el-table-column
                  v-for="language in localizationList"
                  :key="language.LocalizationTypeGuid"
                  :label="
                    language.LocalizationTypeCode +
                    ' (' +
                    language.LocalizationTypeName +
                    ')'
                  "
                  width="250"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="content in scope.row.LocalizationalMenus"
                      :key="content.LocalizationTypeGuid"
                    >
                      <input
                        v-show="
                          content.LocalizationTypeGuid ===
                          language.LocalizationTypeGuid
                        "
                        class="form-control"
                        v-model.trim="content.MenuName"
                      />
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="saveLocalization"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增 Modal -->
    <div
      class="modal fade"
      id="createModal"
      tabindex="-1"
      data-backdrop="static"
      data-focus="false"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <ValidationObserver
          ref="createMenu"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="!ParentName">
                {{ i18n("Menu.AddMain") }}
              </span>
              <span v-else>
                <span class="badge badge-primary" style="font-size: 15px">
                  {{ ParentName }}
                </span>
                {{ i18n("Menu.AddSub") }}
              </span>
            </div>
            <div class="modal-body" style="height: 400px">
              <div v-if="!ParentName" class="form-group">
                <ValidationProvider
                  name="icon"
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for=""><span class="mark">*</span>icon</label>
                  <multiselect
                    v-model="icon"
                    placeholder="請選擇"
                    label="title"
                    track-by="title"
                    :options="iconList"
                    :show-labels="false"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <img
                        style="height: 25px"
                        :src="props.option.img"
                        alt="icon"
                      />
                    </template>
                    <template slot="option" slot-scope="props">
                      <img
                        style="height: 30px"
                        :src="props.option.img"
                        alt="icon"
                      />
                    </template>
                  </multiselect>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider
                  :name="i18n('Menu.MenuName')"
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for="create-name">
                    <span class="mark">*</span>
                    {{ i18n("Menu.MenuName") }}
                    <span class="mark">(不可重複)</span>
                  </label>
                  <input
                    type="text"
                    id="create-name"
                    class="form-control"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model="createTemp.MenuName"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>

              <div v-if="ParentName" class="form-group">
                <ValidationProvider
                  :name="i18n('Menu.MenuLink')"
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for="create-link">
                    <span class="mark">*</span>{{ i18n("Menu.MenuLink") }}
                  </label>
                  <input
                    type="text"
                    id="create-link"
                    class="form-control"
                    v-model="createTemp.Link"
                  />
                  <span class="text-danger">{{ errors[0] }} </span>
                </ValidationProvider>
              </div>

              <div v-if="ParentName" class="form-group">
                <label for="">
                  <span class="mark">*</span>{{ i18n("Menu.ExternalLink") }}
                </label>
                <select class="form-control" v-model="createTemp.ExternalLink">
                  <option :value="true">是</option>
                  <option :value="false">否</option>
                </select>
              </div>

              <template v-if="ParentName">
                <div v-if="!createTemp.ExternalLink" class="form-group">
                  <label for="">
                    <span class="mark">*</span>
                    {{ i18n("Menu.OpenAnotherWindow") }}
                  </label>
                  <select class="form-control" v-model="createTemp.NewWindow">
                    <option :value="true">是</option>
                    <option :value="false">否</option>
                  </select>
                </div>
              </template>

              <el-collapse v-model="collapseOpen" accordion>
                <el-collapse-item
                  title="多國語系"
                  name="1"
                  class="el-collapse-header"
                >
                  <div class="w-100">
                    <template v-for="(language, index) in localizationList">
                      <label
                        :for="`createLanguage${index}`"
                        :key="language.LocalizationTypeGuid"
                      >
                        {{ language.LocalizationTypeName }}
                      </label>
                      <input
                        :id="`createLanguage${index}`"
                        class="form-control w-100 mb-2"
                        :key="language.LocalizationTypeCode"
                        v-model.trim="language.MenuName"
                      />
                    </template>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(createMenu)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 編輯 Modal -->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      data-backdrop="static"
      data-focus="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="editMenu"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="!ParentName">{{ i18n("Menu.EditMain") }}</span>
              <span v-else>{{ i18n("Menu.EditSub") }}</span>
            </div>
            <div class="modal-body" style="height: 400px">
              <div v-if="!ParentName" class="form-group">
                <ValidationProvider
                  name="icon"
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for=""><span class="mark">*</span>icon</label>
                  <multiselect
                    v-model="icon"
                    placeholder="請選擇"
                    label="title"
                    track-by="title"
                    :options="iconList"
                    :show-labels="false"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <img
                        style="height: 25px"
                        :src="props.option.img"
                        alt="icon"
                      />
                    </template>
                    <template slot="option" slot-scope="props">
                      <img
                        style="height: 30px"
                        :src="props.option.img"
                        alt="icon"
                      />
                    </template>
                  </multiselect>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider
                  :name="i18n('Menu.MenuName')"
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for="edit-name">
                    <span class="mark">*</span>
                    {{ i18n("Menu.MenuName") }}
                  </label>
                  <input
                    type="text"
                    id="edit-name"
                    class="form-control"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model="editTemp.MenuName"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div v-if="canEdit" class="form-group">
                <ValidationProvider
                  :name="i18n('Menu.MenuLink')"
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for="edit-link">
                    <span class="mark">*</span>
                    {{ i18n("Menu.MenuLink") }}
                  </label>
                  <input
                    type="text"
                    id="edit-link"
                    class="form-control"
                    v-model="editTemp.Link"
                  />
                  <span class="text-danger">{{ errors[0] }} </span>
                </ValidationProvider>
              </div>

              <div v-if="ParentName" class="form-group">
                <label for="">{{ i18n("Menu.OpenAnotherWindow") }}</label>
                <select class="form-control" v-model="editTemp.NewWindow">
                  <option :value="true">是</option>
                  <option :value="false">否</option>
                </select>
              </div>

              <div v-if="canEdit" class="form-group">
                <label for="">
                  <span class="mark">*</span>
                  {{ i18n("Menu.ExternalLink") }}
                </label>
                <select class="form-control" v-model="editTemp.ExternalLink">
                  <option :value="true">是</option>
                  <option :value="false">否</option>
                </select>
              </div>

              <el-collapse v-model="collapseOpen" accordion>
                <el-collapse-item
                  title="多國語系"
                  name="1"
                  class="el-collapse-header"
                >
                  <div class="w-100">
                    <template
                      v-for="(language, index) in editTemp.LocalizationalMenus"
                    >
                      <label
                        :for="`editLanguage${index}`"
                        :key="language.LocalizationTypeGuid"
                      >
                        {{ language.LocalizationTypeName }}
                      </label>
                      <input
                        :id="`editLanguage${index}`"
                        class="form-control w-100 mb-2"
                        :key="language.LocalizationTypeCode"
                        v-model.trim="language.MenuName"
                      />
                    </template>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(editMenu)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div class="modal fade" id="delMenu" tabindex="-1" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">{{ i18n("Menu.DeleteMenu") }}</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ deleteTemp.MenuName }}</span
            >
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delMenu"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import VueTreeGrid from "@reallife/vue-tree-grid";

export default {
  name: "Menu",

  components: {
    VueTreeGrid,
  },
  data() {
    return {
      // compositionstart& compositionend
      is_composing: false,

      // 目前所選語言
      currentLanguage: null,

      // 主選單名稱
      ParentName: null,

      // 新增選單
      createTemp: {},

      // 編輯選單
      editTemp: {},
      canEdit: false, // 能否編輯

      // 多國語系輸入框預設不展開
      collapseOpen: "",

      // 刪除選單
      deleteTemp: {},

      // 語系列表
      localizationList: [],
      // 多國語系table
      tableData: [],
      originalData: [],

      // 樹狀選單table
      treeKey: 0,
      tree: [],
      treePath: null,
      columns: [
        {
          type: "prop",
          prop: "sort",
          width: "5%",
        },
        {
          label: this.i18n("Menu.MenuName"),
          type: "prop",
          prop: "menuName",
          width: "25%",
        },
        {
          label: this.i18n("Menu.MenuLink"),
          prop: "Link",
          width: "25%",
        },
        {
          type: "prop",
          prop: "action",
          label: "",
          width: "5%",
        },
      ],

      // icon
      icon: {},
      // 選單icon列表
      iconList: [
        {
          title: "calendar-outline",
          img: require("@/assets/icon/calendar-outline.png"),
        },
        {
          title: "clipboard-outline",
          img: require("@/assets/icon/clipboard-outline.png"),
        },
        {
          title: "cloud-download-outline",
          img: require("@/assets/icon/cloud-download-outline.png"),
        },
        {
          title: "email-outline",
          img: require("@/assets/icon/email-outline.png"),
        },
        {
          title: "eye-outline",
          img: require("@/assets/icon/eye-outline.png"),
        },
        {
          title: "facebook-outline",
          img: require("@/assets/icon/facebook-outline.png"),
        },
        {
          title: "file-text-outline",
          img: require("@/assets/icon/file-text-outline.png"),
        },
        {
          title: "folder-outline",
          img: require("@/assets/icon/folder-outline.png"),
        },
        {
          title: "image-outline",
          img: require("@/assets/icon/image-outline.png"),
        },
        {
          title: "inbox-outline",
          img: require("@/assets/icon/inbox-outline.png"),
        },
        {
          title: "link-2-outline",
          img: require("@/assets/icon/link-2-outline.png"),
        },
        {
          title: "message-square-outline",
          img: require("@/assets/icon/message-square-outline.png"),
        },
        {
          title: "options-2-outline",
          img: require("@/assets/icon/options-2-outline.png"),
        },
        {
          title: "people-outline",
          img: require("@/assets/icon/people-outline.png"),
        },
        {
          title: "person-add-outline",
          img: require("@/assets/icon/person-add-outline.png"),
        },
        {
          title: "person-outline",
          img: require("@/assets/icon/person-outline.png"),
        },
        {
          title: "pie-chart-outline",
          img: require("@/assets/icon/pie-chart-outline.png"),
        },
        {
          title: "printer-outline",
          img: require("@/assets/icon/printer-outline.png"),
        },
        {
          title: "search-outline",
          img: require("@/assets/icon/search-outline.png"),
        },
        {
          title: "settings-outline",
          img: require("@/assets/icon/settings-outline.png"),
        },
        {
          title: "share-outline",
          img: require("@/assets/icon/share-outline.png"),
        },
        {
          title: "toggle-right-outline",
          img: require("@/assets/icon/toggle-right-outline.png"),
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["lang"]),
  },

  watch: {
    localizationList: function () {
      this.getMenu();
    },

    lang: function () {
      this.columns = [
        { type: "prop", prop: "sort", width: "5%" },
        { label: this.i18n("Menu.MenuName"), prop: "MenuName", width: "25%" },
        { label: this.i18n("Menu.MenuLink"), prop: "Link", width: "25%" },
        { type: "prop", prop: "action", label: "", width: "5%" },
      ];
    },
  },

  methods: {
    // 取得 選單
    getMenu() {
      this.updateLoading(true);

      this.$api.menu.getMenu().then((response) => {
        if (response.status === 200) {
          this.treeKey++;

          // 建立樹狀資料結構
          this.tree = response.data.map((item) => this.buildTreeItem(item));

          if (this.treePath !== null) {
            this.tree[this.treePath]._isExpanded = true;
          }

          // 建立表格資料
          this.tableData = response.data.map((item) =>
            this.buildTableRow(item)
          );

          this.originalData = JSON.parse(JSON.stringify(this.tableData));
          this.$store.commit("EDITMENU", false);
        }

        this.updateLoading(false);
      });
    },

    // 處理樹狀節點
    buildTreeItem(item) {
      const children = item.Children.map((child) => ({
        ...child,
        childrenLength: item.Children.length,
      }));

      return {
        ...item,
        children,
        _isExpanded: false,
      };
    },

    // 處理表格主資料
    buildTableRow(item) {
      return {
        MenuGuid: item.Guid,
        MenuName: item.MenuName,
        LocalizationalMenus: this.mapLocalizations(item.LocalizationalMenus),
        Children: item.Children.map((child) => this.buildChildRow(child)),
      };
    },

    // 處理表格子資料
    buildChildRow(child) {
      return {
        MenuGuid: child.Guid,
        MenuName: child.MenuName,
        LocalizationalMenus: this.mapLocalizations(child.LocalizationalMenus),
      };
    },

    // 處理語系對應資料
    mapLocalizations(localizationalMenus = []) {
      return this.localizationList.map((defaultLocal) => {
        const matched = localizationalMenus.find(
          (existLocal) =>
            existLocal.LocalizationTypeGuid ===
            defaultLocal.LocalizationTypeGuid
        );
        return (
          matched || {
            LocalizationTypeGuid: defaultLocal.LocalizationTypeGuid,
            MenuName: "",
          }
        );
      });
    },

    // 延續展開 選單
    expandMenu(row) {
      this.treePath =
        this.treePath === Number(row._path) ? null : Number(row._path);
    },

    // 排序 選單
    changeSort({ item, action }) {
      this.updateLoading(true);
      this.$api.menu
        .sortMenu({
          MenuGuid: item.Guid,
          Turn: action,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit("EDITMENU", true);
            this.$notify({
              title: "成功",
              message: "排序變更成功",
              type: "success",
              duration: 2000,
            });
            this.getMenu();
          }
          this.updateLoading(false);
        });
    },

    // 儲存 多國語系
    saveLocalization() {
      $("#localizationModal").modal("hide");
      this.updateLoading(true);
      // 主選單
      const mainMenu = this.tableData.map((parent) => {
        return {
          MenuGuid: parent.MenuGuid,
          LocalizationalMenus: parent.LocalizationalMenus.map((item) => {
            return {
              LocalizationTypeGuid: item.LocalizationTypeGuid,
              MenuName: item.MenuName,
            };
          }),
        };
      });
      // 子選單
      const subMenu = this.tableData
        .map((parent) => parent.Children)
        .flat()
        .map((children) => {
          return {
            MenuGuid: children.MenuGuid,
            LocalizationalMenus: children.LocalizationalMenus.map((item) => {
              return {
                LocalizationTypeGuid: item.LocalizationTypeGuid,
                MenuName: item.MenuName,
              };
            }),
          };
        });

      let menu = {
        LocalizationalMenus: mainMenu.concat(subMenu),
      };
      this.$api.menu.setMenuLocalization(menu).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "儲存成功",
            type: "success",
            duration: 2000,
          });
          this.$store.commit("EDITMENU", true);
          this.getMenu();
        }
        this.updateLoading(false);
      });
    },

    // 新增 選單 Modal
    createMenuModal({ type, data }) {
      this.collapseOpen = ""; // 摺疊預設關閉
      this.ParentName = null; // 上層選單名稱
      this.createTemp = {};
      this.icon = null;
      switch (type) {
        case "parent":
          this.createTemp.ParentMenuGuid = null;
          this.$set(this.createTemp, "Link", "--");
          this.$set(this.createTemp, "NewWindow", false);
          this.$set(this.createTemp, "ExternalLink", false);
          break;
        case "child":
          this.ParentName = data.MenuName;
          this.createTemp.ParentMenuGuid = data.Guid;
          this.$set(this.createTemp, "NewWindow", false);
          this.$set(this.createTemp, "ExternalLink", true);
          break;
      }
      this.$refs.createMenu.reset();
      $("#createModal").modal("show");
    },

    // 新增 選單
    createMenu() {
      $("#createModal").modal("hide");
      let message = "子選單新增成功";
      let icon = null;
      if (this.createTemp.ParentMenuGuid === null) {
        icon = this.icon.title;
        message = "主選單新增成功";
      }
      this.updateLoading(true);
      this.$api.menu
        .postMenu({
          ...this.createTemp,
          NewWindow: this.createTemp.ExternalLink
            ? true
            : this.createTemp.NewWindow,
          Icon: icon,
          CreateUser: this.$cookies.get("userName"),
          Localization: this.localizationList.map((item) => ({
            LocalizationTypeGuid: item.LocalizationTypeGuid,
            MenuName: item.MenuName ? item.MenuName : "",
          })),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit("EDITMENU", true);
            this.$notify({
              title: "成功",
              message: message,
              type: "success",
              duration: 2000,
            });
            this.getMenu();
          }
          this.updateLoading(false);
        });
    },

    // 編輯 選單 Modal
    editMenuModal(item) {
      this.collapseOpen = ""; // 摺疊預設關閉
      this.ParentName = null; // 上層選單名稱
      this.canEdit = false; // 預設不可編輯

      if (item.ParentMenuGuid) {
        if (item.Link.includes("http")) {
          this.canEdit = true;
        }
        this.ParentName = item.ParentMenuGuid;
      } else {
        this.icon = {
          title: item.Icon,
          img: require(`@/assets/icon/${item.Icon}.png`),
        };
      }

      this.editTemp = { ...item };

      this.editTemp.LocalizationalMenus = this.localizationList.map(
        (defaultLocal) => {
          let filterItem = item.LocalizationalMenus.find(
            (existLocal) =>
              existLocal.LocalizationTypeGuid ===
              defaultLocal.LocalizationTypeGuid
          );
          return (
            filterItem || {
              LocalizationTypeGuid: defaultLocal.LocalizationTypeGuid,
              LocalizationTypeName: defaultLocal.LocalizationTypeName,
              MenuName: "",
            }
          );
        }
      );
      this.$refs.editMenu.reset();
      $("#editModal").modal("show");
    },

    // 編輯選單 API
    editMenu() {
      $("#editModal").modal("hide");
      this.updateLoading(true);
      let icon = null;
      if (this.editTemp.ParentMenuGuid === null) {
        icon = this.icon.title;
      }
      this.$api.menu
        .putMenu({
          ...this.editTemp,
          Localization: this.editTemp.LocalizationalMenus.map((item) => ({
            LocalizationTypeGuid: item.LocalizationTypeGuid,
            MenuName: item.MenuName ? item.MenuName : "",
          })),
          Icon: icon,
          CreateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.dispatch("updateLoading", false);
            this.$notify({
              title: "成功",
              message: "編輯成功",
              type: "success",
              duration: 2000,
            });
            this.getMenu();
          }
          this.updateLoading(false);
        });
    },

    // 刪除 選單
    delMenu() {
      this.updateLoading(true);
      this.$api.menu.deleteMenu(this.deleteTemp.Guid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2000,
          });
          this.getMenu();
        }
        this.updateLoading(false);
      });
    },

    // 取得 語系
    getLocalization() {
      this.updateLoading(true);
      this.$api.localization
        .getLocalizationType({
          isEnabled: null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.localizationList = response.data.map((item) => {
              return {
                LocalizationTypeGuid: item.LocalizationTypeGuid,
                LocalizationTypeCode: item.LocalizationTypeCode,
                LocalizationTypeName: item.LocalizationTypeName,
                MenuName: null,
              };
            });
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.currentLanguage = localStorage.getItem("i18n-lang");
    this.getLocalization();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss">
#localizationModal {
  .modal-dialog .modal-body {
    max-height: none;
    overflow-y: none;
  }
  .modal-body {
    padding: 0 10px 0 10px;
  }
}
.el-table--scrollable-y .el-table__body-wrapper {
  margin-top: 0px;
}

i.tree-grid__expand-icon {
  background-color: #4062c2 !important;
  border-radius: 50% !important;
  color: #fff;
  line-height: 17px !important;
  width: 20px !important;
  height: 20px !important;
  margin-left: -20px;
  font-style: normal;

  &.tree-grid__expand-icon--expanded {
    background-color: #e55353 !important;
  }
}

.tree-grid__body-cell {
  .btn {
    margin-right: 5px;
  }
}

.el-collapse-header {
  .el-collapse-item__header {
    font-size: 16px;
  }
}
</style>
